import React, { FC } from 'react';
import { WarningCircle } from 'common/svg';
import { IAnalyzeChannelsChannelShareShift } from 'entities/AnalyzeChannels/AnalyzeChannels.models';
import { ChannelShareChart } from 'entities/AnalyzeChannels/components/ChannelShareChart';

interface IComponentProps {
  shift: IAnalyzeChannelsChannelShareShift;
  index: number;
}

export const AnalyzeChannelsChannelShareShiftCard: FC<IComponentProps> = ({ shift, index }) => {
  return (
    <div className="ac-channel-share-shift-card">
      <div className="ac-channel-share-shift-card__header">
        <span className="ff-medium fs-xs color-whiteDark">{shift.shift || `Shift ${index}`}</span>
        <WarningCircle className="icon-gray" />
      </div>

      <div className="ac-channel-share-shift-card__body">
        <ChannelShareChart data={{ total: shift.total, days: shift.days }} compact />
      </div>
    </div>
  );
};
